import { Component, inject, signal } from '@angular/core';
import { Router, NavigationEnd, RouterLink, RouterLinkActive } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LucideIconsModule } from '@shared/lucide-icons.module';
import { NotificationService } from '@core/services/notification.service';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.html',
  imports: [
    LucideIconsModule,
    RouterLink,
    RouterLinkActive
  ],
  styleUrls: ['./bottom-nav.scss']
})
export class BottomNavComponent {
  private readonly notificationService = inject(NotificationService);
  readonly unreadCount = this.notificationService.unreadCount;
  readonly unreadBadgeLabel = this.notificationService.unreadBadgeLabel;

  // Show bottom nav on mobile/tablet only
  showBottomNav = signal(true);

  // Current route
  currentRoute = signal('');

  constructor(private router: Router) {
    // Track route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentRoute.set(event.urlAfterRedirects);
      // Hide bottom nav on certain pages (optional)
      const hideOnRoutes = ['/onboarding', '/'];
     // this.showBottomNav.set(!hideOnRoutes.includes(event.urlAfterRedirects));
    });

    // Get initial route
    this.currentRoute.set(this.router.url);
  }

  /**
   * Check if route is active (for manual active states if needed)
   */
  isActive(route: string): boolean {
    return this.currentRoute().startsWith(route);
  }

  
}
